export const productsKeys = {
  all: ['products'] as const,
  lists: () => [...productsKeys.all, 'list'] as const,
  list: (params: Record<string, any>) =>
    [...productsKeys.lists(), params] as const,

  details: () => [...productsKeys.all, 'detail'] as const,
  detail: (id: number) => [...productsKeys.details(), id] as const,

  newCount: (query: string) =>
    [...productsKeys.all, 'newCount', query] as const,
};
